import { Box, Divider } from '@chakra-ui/react';
import { FundRewardTokenForm } from './FundRewardTokenForm';
import { FundBonusTokensForm } from './FundBonusTokensForm';
import { ExtendedRewardProgram } from 'types';
import { FC } from 'react';
import { PowerSwitchStatus } from 'api/blockchain/rewardProgram';

type Props = {
  program: ExtendedRewardProgram;
  programState?: PowerSwitchStatus;
};

export const FundingFormWrapper: FC<Props> = ({ program, programState }) => {
  return (
    <>
      <Box p={4}>
        <FundRewardTokenForm
          rewardToken={program.rewardProgramTokens.rewardToken}
          rewardProgramDataMethod={
            program.rewardProgram.getRewardProgramDataMethod
          }
          rewardProgramFundMethod={
            program.rewardProgram.getRewardProgramFundMethod
          }
          programState={programState}
          aludelAbi={program.rewardProgram.abi}
        />
      </Box>
      <Divider my={4} />
      <Box p={4}>
        <FundBonusTokensForm
          bonusTokens={program.rewardProgramTokens.bonusTokens}
          rewardProgramDataMethod={
            program.rewardProgram.getRewardProgramDataMethod
          }
          programState={programState}
          aludelAbi={program.rewardProgram.abi}
        />
      </Box>
    </>
  );
};
